import { motion } from "framer-motion";
import {
  FaHandshake,
  FaAward,
  FaLightbulb,
  FaUsers,
} from "react-icons/fa";

const CoreValues = () => {
  const values = [
    {
      icon: <FaHandshake />,
      title: "Integrity",
      description:
        "We believe in honesty, transparency and ethical business practices in every project we undertake.",
    },
    {
      icon: <FaAward />,
      title: "Quality",
      description:
        "We are committed to delivering superior craftsmanship and maintaining the highest construction standards.",
    },
    {
      icon: <FaLightbulb />,
      title: "Innovation",
      description:
        "We embrace modern technologies, creative solutions and industry best practices to achieve excellence.",
    },
    {
      icon: <FaUsers />,
      title: "Commitment",
      description:
        "Our team is dedicated to meeting client expectations through reliability, accountability and professionalism.",
    },
  ];

  return (
    <section className="py-24 bg-slate-50 overflow-hidden">
      <div className="container-custom">

        {/* Section Header */}

        <div className="text-center max-w-3xl mx-auto mb-16">

          <span className="text-[#F59E0B] uppercase tracking-widest font-semibold">
            Core Values
          </span>

          <h2 className="text-4xl lg:text-5xl font-bold text-[#082B57] mt-4">
            The Values That
            <span className="text-[#F59E0B]"> Define Us</span>
          </h2>

          <p className="text-gray-600 mt-6 leading-8">
            Our values are the foundation of every project,
            partnership and client relationship we build.
          </p>

        </div>

        {/* Values Grid */}

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">

          {values.map((value, index) => (
            <motion.div
              key={index}
              initial={{
                opacity: 0,
                y: 50,
              }}
              whileInView={{
                opacity: 1,
                y: 0,
              }}
              transition={{
                duration: 0.5,
                delay: index * 0.1,
              }}
              viewport={{ once: true }}
              className="group bg-white rounded-3xl p-8 shadow-lg border border-gray-100 hover:shadow-2xl hover:-translate-y-3 transition-all duration-500"
            >

              {/* Icon */}

              <div className="w-20 h-20 rounded-2xl bg-[#082B57]/10 flex items-center justify-center text-3xl text-[#082B57] group-hover:bg-[#F59E0B] group-hover:text-white transition-all duration-500">
                {value.icon}
              </div>

              {/* Title */}

              <h3 className="text-2xl font-bold text-[#082B57] mt-6">
                {value.title}
              </h3>

              {/* Description */}

              <p className="text-gray-600 leading-7 mt-4">
                {value.description}
              </p>

            </motion.div>
          ))}

        </div>

      </div>
    </section>
  );
};

export default CoreValues;